import { Injectable } from '@angular/core';
import querystring from 'query-string';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IToken } from '../interfaces/token.interface';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class ApiService {
  private http: HttpClient;

  private headers: object = {
    'Accept': 'html/text',
    'Content-Type': 'text/plain;charset=UTF-8'
    // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
    // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
  };

  private headers2: object = {
    'Accept': 'html/text',
    'Content-Type': 'application/x-www-form-urlencoded'
    // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
    // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
  };

  constructor(http: HttpClient, public authService: AuthService) {
    this.http = http;
  }

  public post(data: any, path: string, isSecure: boolean): Promise<any> {
    const headers = {
      ...this.headers2
    };

    const searchParams = Object.keys(data).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');

    return new Promise((resolve, reject) => {
      this.http.post(`${environment.api}/${path}`, searchParams,  {
        headers: new HttpHeaders({
          'Accept': 'html/text',
          'Content-Type': 'application/x-www-form-urlencoded'
          // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
          // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
        })
      }).toPromise()
        .then((response: any) => {
          return resolve(response);
        })
        .catch(error => {
          return reject(error);
        });
    });
  }

  public get(path: string, isSecure: boolean): Promise<any> {
    const headers = {
      ...this.headers2
    };
/**
 *
 *
    res.setHeader('Access-Control-Allow-Origin', 'http://localhost:8888');

    // Request methods you wish to allow
    res.setHeader('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE');

    // Request headers you wish to allow
    res.setHeader('Access-Control-Allow-Headers', 'X-Requested-With,content-type');

    // Set to true if you need the website to include cookies in the requests sent
    // to the API (e.g. in case you use sessions)
    res.setHeader('Access-Control-Allow-Credentials', true);

 *
 */
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.api}/${path}`,  {
        headers: new HttpHeaders({
          'Accept': 'html/text',
          'Content-Type': 'application/x-www-form-urlencoded'
          // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
          // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
        })
      }).toPromise()
        .then((response: any) => {
          return resolve(response);
        })
        .catch(error => {
          return reject(error);
        });
    });
  }

  public get2(path: string, isSecure: boolean): Promise<any> {
    const headers = {
      ...this.headers2
    };

    return new Promise((resolve, reject) => {
      this.http.get(`${path}`,  {
        headers: new HttpHeaders({
          'Accept': 'html/text',
          'Content-Type': 'application/x-www-form-urlencoded'
          // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
          // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
        })
      }).toPromise()
        .then((response: any) => {
          return resolve(response);
        })
        .catch(error => {
          return reject(error);
        });
    });
  }
}
